import { combineReducers } from 'redux';

import { getIsCpmAudio } from '../AddCreativePage/AddVideoCreative/helpers';
import { addCreative, addCreativeInitialState } from '../AddCreativePage/reducers';
import { commonCanvasData, getCommonDataInitialState } from '../CanvasApp/reducers';
import { commonCreatives, getInitialCommonCreativesState } from '../CommonCreatives/reducers';
import { creativeImageCropModal, creativeImageCropModalInitialState } from '../CreativeImageCropModal/reducers';
import { creativeSmartCenterModal, creativeSmartCenterModalInitialState } from '../CreativeSmartCenterModal/reducers';
import { fileEditors } from '../FileEditor/reducers';
import { getGalleriesInitialState } from '../GalleryPane/helpers';
import { galleries } from '../GalleryPane/reducers';
import { getIdeasListInitialState, ideasList } from '../IdeasList/reducers';
import { getInitialPresetsState, presets } from '../Presets/reducers';
import { uploadByLinkModal, uploadByLinkModalInitialState } from '../UploadByLinkModal/reducers';
import { getVideoCreativesInitialState, videoCreatives } from '../VideoCreatives/reducers';

import { CanvasState } from './state';
import { initialSharedData, SharedData } from './typings';

export const getCanvasInitialState = (sharedData: SharedData = initialSharedData): CanvasState => ({
    commonData: getCommonDataInitialState(),
    presets: getInitialPresetsState(sharedData.creativeType),
    ideasList: getIdeasListInitialState(),
    commonCreatives: getInitialCommonCreativesState(sharedData),
    videoCreatives: getVideoCreativesInitialState(getIsCpmAudio(sharedData)),
    addCreative: addCreativeInitialState(sharedData.creativeType),
    fileEditors: {},
    uploadByLinkModal: uploadByLinkModalInitialState,
    galleries: getGalleriesInitialState(),
    creativeImageCropModal: creativeImageCropModalInitialState,
    creativeSmartCenterModal: creativeSmartCenterModalInitialState
});

export const canvasReducer = combineReducers({
    commonData: commonCanvasData,
    presets,
    ideasList,
    commonCreatives,
    videoCreatives,
    addCreative,
    fileEditors,
    uploadByLinkModal,
    galleries,
    creativeSmartCenterModal,
    creativeImageCropModal
});
